module.exports = __webpack_public_path__ + "img/equifax.3dcf7a4f.svg";